import { useEffect, useState } from "react";
import { db } from "../firebase/firebase";
import { doc, getDoc } from "firebase/firestore";

export default function useFeaturesGate(businessId){
  const [features, setFeatures] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    // 🔒 HARD STOP — prevents infinite loading
    if (!businessId || businessId === "disabled") {
      setFeatures({});
      setLoading(false);
      return;
    }

    (async () => {
      try {
        const snap = await getDoc(
          doc(db, "businesses", businessId, "settings", "features")
        );

        if (!cancelled) {
          setFeatures(snap.exists() ? snap.data() : {});
        }
      } catch (err) {
        console.warn("Feature gate skipped:", err.message);
        if (!cancelled) setFeatures({});
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [businessId]);

  return { features, loading };
}
